// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!/app/node_modules/css-loader/dist/cjs.js!/app/ui/src/vendor/jquery-file-upload/css/jquery.fileupload.css");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!/app/node_modules/style-loader/addStyles.js")(content, {});
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	module.hot.accept("!!/app/node_modules/css-loader/dist/cjs.js!/app/ui/src/vendor/jquery-file-upload/css/jquery.fileupload.css", function() {
		var newContent = require("!!/app/node_modules/css-loader/dist/cjs.js!/app/ui/src/vendor/jquery-file-upload/css/jquery.fileupload.css");
		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
		update(newContent);
	});
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./ui/src/vendor/jquery-file-upload/css/jquery.fileupload.css
// module id = 792
// module chunks = 1